import script from "./QuizModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizModal.vue?vue&type=script&setup=true&lang=js"

import "./QuizModal.vue?vue&type=style&index=0&id=10137a10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10137a10"]])

export default __exports__